import styled, { css } from 'styled-components';
export const animatableIconStyles = ({ theme, $animation, }) => css `
	position: relative;
	transition-duration: ${theme.timing['300']}ms;
	transform-style: cubic-bezier(${theme.easings.default});

	${$animation === 'right' &&
    css `
		transition-property: left;
		left: 0;

		a:hover &,
		button:hover & {
			left: 3px;
		}
	`}

	${$animation === 'left' &&
    css `
		transition-property: right;
		right: 0;

		a:hover &,
		button:hover & {
			right: 3px;
		}
	`}
`;
export const AnimatableIcon = styled.span `
	${animatableIconStyles}
`;
